
const cosmicReadings = [
  { value: "████", label: "Signal Coherence", unit: "Hz" },
  { value: "∞", label: "Void Resonance", unit: "dB" },
  { value: "7.3", label: "Dimensional Flux", unit: "∇" },
  { value: "█ █ █", label: "Neural Interfaces", unit: "Active" }
];

const transmissions = [
  {
    entityId: "ENTITY-7A2",
    timestamp: "2024.███.██ 03:47:22",
    signal: "Weak/Intermittent",
    text: "The flesh responds to frequencies I never knew existed. The boundaries between self and █████ have begun to dissolve. I am... changing.",
    corruption: "12%"
  },
  {
    entityId: "SIGNAL_UNKNOWN",
    timestamp: "█████.12.21 ██:██:██",
    signal: "Strong/Distorted",
    text: "Weight is merely a concept. I have shed more than pounds—I have shed the illusion of limitation. The monoliths whisper truths.",
    corruption: "34%"
  },
  {
    entityId: "TX-███",
    timestamp: "CALIBRATION_ERROR",
    signal: "Unstable",
    text: "Day ███: The transformation accelerates. My body obeys commands from sources I cannot identify. Progress measured in dimensions beyond the physical.",
    corruption: "67%"
  }
];

const SocialProofSection = () => {
  return (
    <section className="w-full py-20 md:py-32 relative bg-zinc-900">
      <div className="absolute inset-0 bg-noise opacity-15 z-0"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-25 z-0"></div>
      
      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
        {/* Cosmic Readings Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-green-400 mb-8 glitch-title">
            Current Cosmic Readings
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {cosmicReadings.map((reading, index) => (
              <div key={index} className="border border-gray-700 bg-black/60 p-4 text-center relative overflow-hidden">
                <div className="absolute inset-0 bg-green-500/5 animate-pulse"></div>
                <div className="text-2xl md:text-3xl font-bold text-green-400 mb-2 font-mono">
                  {reading.value}
                </div>
                <div className="text-gray-400 text-xs analog-text">
                  {reading.label}
                </div>
                <div className="text-green-500 text-xs font-mono mt-1">
                  [{reading.unit}]
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Intercepted Transmissions */}
        <div className="space-y-8">
          <h3 className="text-2xl md:text-3xl font-bold text-green-400 text-center mb-12">
            Intercepted Transmissions
          </h3>
          
          <div className="space-y-6">
            {transmissions.map((transmission, index) => (
              <div key={index} className="border border-gray-700 bg-zinc-900/70 relative overflow-hidden">
                {/* Terminal Header */}
                <div className="bg-black text-green-400 px-4 py-2 flex items-center justify-between text-xs font-mono">
                  <div className="flex items-center space-x-4">
                    <span>ENTITY: {transmission.entityId}</span>
                    <span>TIMESTAMP: {transmission.timestamp}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-yellow-400">SIGNAL: {transmission.signal}</span>
                    <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                  </div>
                </div>
                
                {/* Transmission Content */}
                <div className="p-6 relative">
                  <div className="absolute top-0 right-0 text-xs text-red-400 font-mono">
                    CORRUPTION: {transmission.corruption}
                  </div>
                  
                  <p className="text-gray-300 analog-text leading-relaxed text-sm md:text-base">
                    {transmission.text.split('█').map((part, i) => 
                      i > 0 ? (
                        <span key={i}>
                          <span className="bg-red-500 text-black px-1 animate-pulse">█</span>
                          {part}
                        </span>
                      ) : part
                    )}
                  </p>
                  
                  {/* Visual corruption effects */}
                  <div className="absolute inset-0 pointer-events-none">
                    <div className="scanline opacity-30"></div>
                    <div className="noise opacity-20"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="text-center mt-12 text-xs analog-text text-gray-500 border border-gray-800 p-4 bg-black/50">
          <p className="text-red-400 mb-2">⚠ TRANSMISSION QUALITY DEGRADED ⚠</p>
          <p>Entities report experiences beyond current measurement parameters</p>
          <p className="mt-2 font-mono">Signal strength varies by dimensional alignment</p>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
